<template>
<div id="Q0" class="sub">
  <div class="wrapper">
    <kg-header :headerType="Number(headerType)" />
    <div id="content">
      <div class="inner_static">
        <div id="register">
          <h1 class="tit1">お問い合わせ</h1>
          <p class="att_contact">
            ※事前に<a @click="faqClick()">FAQ</a>をご確認ください。
          <p>
          <ul class="lst_register">
            <li>
              <div class="item">
                <label for="contact1">【お問い合わせ内容】<strong class="req">※必須</strong></label>
              </div>
              <div class="cnt">
                <select id="contact1" name="contact1" class="sel type2" v-model="contactData.type">
                  <option v-for="(faq,index) in faqList" :key="index" v-bind:value="faq.type">{{faq.typeText}}</option>
                </select>
              </div>
              <div v-if="this.errors['type']" class="error_text">{{this.errors['type']}}</div>
            </li>
            <li>
              <div class="item">
                <label for="contact2">【お問い合わせ件名】<strong class="req">※必須</strong></label>
              </div>
              <div class="cnt">
                <input type="text" id="contact2" name="contact2" class="int" v-model="contactData.title">
              </div>
              <div v-if="this.errors['title']" class="error_text">{{this.errors['title']}}</div>
            </li>
            <li>
              <div class="item">
                <label for="contact3">【お問い合わせ内容】<strong class="req">※必須</strong></label>
              </div>
              <div class="cnt">
                <textarea id="contact3" name="contact3" class="txta" v-model="contactData.body"></textarea>
              </div>
              <div v-if="this.errors['body']" class="error_text">{{this.errors['body']}}</div>
            </li>
            <li>
              <div class="item">
                <label for="contact4-1">【ご氏名】<strong class="req">※必須</strong></label>
              </div>
              <div class="cnt">
                <div class="ins_wrap">
                  <div class="name">
                    <input type="text" id="contact4-1" name="contact4-1" class="int"
                        v-model="contactData.lastName" placeholder="家具">
                  </div>
                  <div class="name">
                    <input type="text" id="contact4-2" name="contact4-2" class="int"
                        v-model="contactData.firstName" placeholder="太郎">
                  </div>
                </div>
              </div>
              <div v-if="this.errors['lastName']" class="error_text">{{this.errors['lastName']}}</div>
              <div v-if="this.errors['firstName']" class="error_text">{{this.errors['firstName']}}</div>
            </li>
            <li>
              <div class="item">
                <label for="contact5-1">【ご氏名（カナ）】<strong class="req">※必須</strong></label>
              </div>
              <div class="cnt">
                <div class="ins_wrap">
                  <div class="name">
                    <input type="text" id="contact5-1" name="contact5-1" class="int"
                        v-model="contactData.lastNameKana" placeholder="カグ">
                  </div>
                  <div class="name">
                    <input type="text" id="contact5-2" name="contact5-2" class="int"
                        v-model="contactData.firstNameKana" placeholder="タロウ ">
                  </div>
                </div>
              </div>
              <div v-if="this.errors['lastNameKana']" class="error_text">{{this.errors['lastNameKana']}}</div>
              <div v-if="this.errors['firstNameKana']" class="error_text">{{this.errors['firstNameKana']}}</div>
            </li>
          <li>
            <div class="item">
              <label for="contact6">【メールアドレス】<strong class="req">※必須</strong></label>
            </div>
            <div class="cnt">
              <input type="text" id="contact6" name="contact6" class="int"
                  v-model="contactData.email" placeholder="****@domans.co.jp">
            </div>
            <div v-if="this.errors['email']" class="error_text">{{this.errors['email']}}</div>
          </li>
          </ul>
          <div class="btn_area">
            <a class="btn1" @click="confirm()">お問い合わせ内容の確認</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import * as App from '../../utils/App'
import {KG_STORAGE_KEY} from '../../constants/App'

// kaggul Module
import Header from '../components/common/HomeIconHeader'
import * as Check from '../../utils/Check'

export default {
  components: {
    'kg-header': Header
  },
  props: {
    headerType: {
      type: String,
      default: '0'
    }
  },
  data () {
    return {
      // この内容はFAQと連動するとのことなのでその機能がつくまでは同じ内容でコピーする
      faqList: [
        {type: 0, typeText: 'お問い合わせ内容をお選びください', questions: []},
        {type: 1, typeText: 'アプリについて', questions: []},
        {type: 2, typeText: '商品について', questions: []},
        {type: 3, typeText: '購入後の商品について', questions: []},
        {type: 4, typeText: 'オプションについて', questions: []},
        {type: 5, typeText: 'カグルについて', questions: []},
        {type: 6, typeText: 'カグラーについて', questions: []},
        {type: 7, typeText: 'その他について', questions: []}
      ],
      contactData: {
        type: 0,
        typeText: '', // 確認画面で文言を表示するため
        title: '',
        body: '',
        lastName: '',
        firstName: '',
        lastNameKana: '',
        firstNameKana: '',
        email: ''
      },
      errors: {}
    }
  },
  methods: {
    faqClick: function () {
      this.$router.push('/kagull/faq/' + this.headerType)
    },
    confirm: function () {
      this.errors = {}
      if (!this.validate()) return
      this.contactData.typeText =
        this.faqList.find(faq => faq.type === this.contactData.type).typeText
      App.setLocalStorage(KG_STORAGE_KEY.CONTACT_DATA, this.contactData)
      this.$router.push('/kagull/support/confirm/' + this.headerType)
    },
    validate: function () {
      let isValid = true
      if (this.contactData.type === 0) {
        this.errors['type'] = 'お問い合わせ内容を選択してください。'
        isValid = false
      }
      if (this.contactData.title == null || this.contactData.title === '') {
        this.errors['title'] = 'お問い合わせ件名は必須です。'
        isValid = false
      } else if (this.contactData.title.length > 32) {
        this.errors['title'] = 'お問い合わせ件名は32文字以内で入力してください。'
        isValid = false
      }
      if (this.contactData.body == null || this.contactData.body === '') {
        this.errors['body'] = 'お問い合わせ内容は必須です。'
        isValid = false
      } else if (this.contactData.body.length > 256) {
        this.errors['body'] = 'お問い合わせ内容は256文字以内で入力してください。'
        isValid = false
      }
      if (this.contactData.lastName == null || this.contactData.lastName === '' ||
        this.contactData.firstName == null || this.contactData.firstName === '') {
        this.errors['lastName'] = '氏名は必須です。'
        isValid = false
      } else if (this.contactData.lastName.length > 32 || this.contactData.firstName.length > 32) {
        this.errors['lastName'] = '氏名は32文字以内で入力してください。'
        isValid = false
      }
      if (this.contactData.lastNameKana == null || this.contactData.lastNameKana === '' ||
        this.contactData.firstNameKana == null || this.contactData.firstNameKana === '') {
        this.errors['lastNameKana'] = '氏名（カナ）は必須です。'
        isValid = false
      } else if (!Check.isKana(this.contactData.lastNameKana) || !Check.isKana(this.contactData.firstNameKana)) {
        this.errors['lastNameKana'] = '氏名（カナ）カタカナで入力してください。'
        isValid = false
      } else if (this.contactData.lastNameKana.length > 32 || this.contactData.firstNameKana.length > 32) {
        this.errors['lastNameKana'] = '氏名（カナ）32文字以内で入力してください。'
        isValid = false
      }
      if (this.contactData.email == null || this.contactData.email === '') {
        this.errors['email'] = 'メールアドレスは必須です。'
        isValid = false
      } else if (!Check.isMail(this.contactData.email)) {
        this.errors['email'] = 'メールアドレスの形式ではありません。'
        isValid = false
      } else if (this.contactData.email.length > 128) {
        this.errors['email'] = 'メールアドレスは128文字以内で入力してください。'
        isValid = false
      }
      return isValid
    }
  },
  created: function () {
    let contactData = App.getLocalStorage(KG_STORAGE_KEY.CONTACT_DATA)
    if (Object.keys(contactData).length > 0) {
      this.contactData.type = contactData.type
      this.contactData.typeText = contactData.typeText
      this.contactData.title = contactData.title
      this.contactData.body = contactData.body
      this.contactData.lastName = contactData.lastName
      this.contactData.firstName = contactData.firstName
      this.contactData.lastNameKana = contactData.lastNameKana
      this.contactData.firstNameKana = contactData.firstNameKana
      this.contactData.email = contactData.email
    }
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/ContactInput.vue